import { createHeroIcon } from "#components/ui/createHeroIcon.tsx";

// Heroicons 20/solid "chat-bubble-left-right" (MIT)
const BACK_BUBBLE_PATH = [
    "M3.505 2.365A41.369 41.369 0 0 1 9 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268",
    "a4.45 4.45 0 0 0-.577-.069 43.141 43.141 0 0 0-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24",
    "c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 0 1 5 17.25v-3.443c-.501-.048-1-.106-1.495-.172",
    "C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914Z"
].join("");
const FRONT_BUBBLE_PATH = [
    "M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24",
    "c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 0 0 1.28-.531",
    "v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0 0 14 6Z"
].join("");

export const HeroChatBubbleLeftRightIcon = createHeroIcon(
    <>
        <path d={BACK_BUBBLE_PATH} />
        <path d={FRONT_BUBBLE_PATH} />
    </>,
    "HeroChatBubbleLeftRightIcon"
);
